__turbopack_context__.v({
  "reviewSliderStylingOverride": "reviewSliderStylingOverride-module__Kp1FWq__reviewSliderStylingOverride",
});
